import { Facebook } from "lucide-react";
import Section from "../components/Section";
import Seo from "../components/Seo";

export default function ReseauxSociaux() {
  return (
    <>
      <Seo
        path="/reseaux-sociaux"
        title="Réseaux sociaux"
        description="Suivez La La Land sur les réseaux sociaux : photos, événements musicaux et nouveautés de nos micro-crèches."
      />
      <Section
      eyebrow="Réseaux sociaux"
      title="Suivez notre quotidien"
      description="Photos, événements musicaux et nouveautés de nos micro-crèches."
    >
      <a
        href="https://www.facebook.com/lalalandcreches/"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-3 bg-surface border border-edge-soft rounded-2xl px-6 py-4 hover:bg-muted transition shadow-soft-sm"
      >
        <Facebook strokeWidth={1.5} />
        <span className="font-medium">Facebook · @lalalandcreches</span>
      </a>
      </Section>
    </>
  );
}
